<template>
  <div>
    <BaseDialog
      :show="show"
      :info="dialogInfo"
      :show-modal="false"
      @cancel="handleCancel"
      @confirm="handelConfirm"
    >
      <div slot="content">
        <el-form
          ref="forgotForm"
          :model="forgotForm"
          :rules="forgotRules"
          class="forgot-form"
        >
          <el-form-item prop="email" :label="$t('form.forgot.email')">
            <TbbInput
              v-model="forgotForm.email"
              :show-pas="true"
              :placeholder="'placeholder.login_username'"
            />
          </el-form-item>

          <el-form-item
            prop="code"
            class="login-forgot-code flex flex-direction-column"
            :label="$t('form.forgot.code')"
          >
            <TbbInput
              v-model="forgotForm.code"
              :show-pas="true"
              :placeholder="'placeholder.verification_code'"
            />
            <el-button class="get-code-btn" type="lightblue" @click="sendCode" style="width: 112px;">
              {{ timeCount ? `${timeCount}s`: $t('button.get_code') }}
            </el-button>
          </el-form-item>

          <el-form-item
            prop="newPassword"
            :label="$t('form.forgot.new_password')"
          >
            <TbbInput
              v-model="forgotForm.newPassword"
              :show-pas="false"
              :show-eye="true"
              :placeholder="'placeholder.new_password'"
            />
          </el-form-item>

          <el-form-item
            prop="againPassword"
            :label="$t('form.forgot.again_password')"
          >
            <TbbInput
              v-model="forgotForm.againPassword"
              :show-pas="false"
              :show-eye="true"
              :placeholder="'placeholder.again_password'"
            />
          </el-form-item>
        </el-form>
      </div>
    </BaseDialog>
  </div>
</template>

<script>
import { sendUserCode } from '@/api/user'

import {
  validateUsername,
  validateCode,
  validatePasswordTest
} from '@/utils/form/rule'

export default {
  name: 'ForgotPasswordDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const that = this
    const validateAgainPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error(that.$t('rules.new_password_empty')))
      } else if (value != that.forgotForm.newPassword) {
        callback(new Error(that.$t('rules.password_no_same')))
      } else if (value.length > 30) {
        callback(new Error(that.$t('rules.warning_max_passwd')))
      } else if (!/[a-z A-Z 0-9-_*&^%$#@!,.?:;/+=]$/.test(value)) {
        callback(new Error(that.$t('rules.error_password_message')))
      } else {
        callback()
      }
    }

    return {
      dialogInfo: {
        title: 'dialog.forgot.title',
        dec: 'dialog.forgot.dec'
      },
      timeCount: 0,
      timer: null,
      forgotForm: {
        email: '',
        code: '',
        newPassword: '',
        againPassword: ''
      },
      forgotRules: {
        email: [
          { required: true, trigger: 'blur', validator: validateUsername },
          {
            type: 'email',
            message: that.$t('rules.email_invalid'),
            trigger: 'change'
          }
        ],
        code: [{ required: true, trigger: 'blur', validator: validateCode }],
        newPassword: [
          { required: true, trigger: 'blur', validator: validatePasswordTest }
        ],
        againPassword: [
          {
            required: true,
            trigger: 'blur',
            validator: validateAgainPassword
          }
        ]
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.resetFields()
    })
  },
  methods: {
    resetFields() {
      this.forgotForm = {
        email: '',
        code: '',
        newPassword: '',
        againPassword: ''
      }
    },
    handleCancel(val) {
      this.$refs['forgotForm'].resetFields()

      this.$emit('cancel', val)
    },
    handelConfirm() {
      this.$refs.forgotForm.validate((valid) => {
        if (valid) {
          this.$store.dispatch('setDialogConfirmBtn', true)

          let formData = JSON.parse(JSON.stringify(this.forgotForm))
          this.$emit('confirm', formData)
        }
      })
    },
    intervalTimer(){
      this.timeCount = 59;
      this.timer = setInterval(() => {
        this.timeCount = this.timeCount - 1

        if(this.timeCount === 0) {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    sendCode() {
      if(this.timeCount) return;
      const params = {
        email: this.forgotForm.email,
        type: 2
      }
      if (params.email) {
        sendUserCode(params).then((res) => {
          if (res) {
            this.intervalTimer()
            this.$message({
              message: this.$t('message.message_send_code_success'),
              type: 'success'
            })
          }
        })
      } else {
        this.$message({
          message: this.$t('message.message_send_code_fail'),
          type: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.login-forgot-code {
  .el-form-item__label {
    text-align: left;
  }
  .el-form-item__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tbb-input {
      width: 290px;
    }
  }
}
.get-code-btn {
  height: 50px !important;
  padding: 0px 20px;
}
</style>
